export default __webpack_public_path__ + "static/media/maria.05c2416e.png";